import { render, staticRenderFns } from "./InsuranceRefundFileLoader.vue?vue&type=template&id=5bb08a86&scoped=true&"
import script from "./InsuranceRefundFileLoader.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundFileLoader.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRefundFileLoader.vue?vue&type=style&index=0&id=5bb08a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb08a86",
  null
  
)

export default component.exports